module.exports = __webpack_public_path__ + "img/templates-search.4fa1c950.png";